var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "#FF0000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.551 0.73408C32.0191 1.12949 33.1769 2.28697 33.572 3.75539C34.3064 6.43752 34.2781 12.0282 34.2781 12.0282C34.2781 12.0282 34.2781 17.5905 33.5723 20.2728C33.1769 21.741 32.0194 22.8987 30.551 23.2939C27.8686 24 17.1393 24 17.1393 24C17.1393 24 6.43801 24 3.72764 23.2659C2.25922 22.8705 1.10174 21.7128 0.706325 20.2446C0.000488281 17.5905 0.000488281 12 0.000488281 12C0.000488281 12 0.000488281 6.43752 0.706325 3.75539C1.10148 2.28723 2.28746 1.10125 3.72738 0.706098C6.40976 0 17.139 0 17.139 0C17.139 0 27.8686 0 30.551 0.73408ZM22.6451 12L13.7228 17.1389V6.86118L22.6451 12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cc6ca8e395231b2dc81714cb69007e0d.svg";
export { ForwardRef as ReactComponent };